import { css } from '@compiled/react';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { TEMPLATE_CARD_BACKGROUNDS } from '@/components/confluence/templates/template-card-grid';

import { SkeletonTemplateCard } from './skeleton-template-card';

const gridContainerStyles = css({
	display: 'flex',
	flexWrap: 'wrap',
	listStyle: 'none',
	listStylePosition: 'inside',
	paddingInlineStart: 0,
	margin: 0,
	gap: 64,
	'@media (min-width: 40rem) and (max-width: 63.99rem)': {
		width: '676px',
		gap: '32px',
	},
	justifyContent: 'center',
});

const gridItemStyles = css({
	listStyleType: 'none',
	display: 'flex',
	flexWrap: 'wrap',
	listStyle: 'none',
	opacity: 1,
});

export const SkeletonTemplateRecommendationCardGrid = () => {
	const NUMBER_OF_PLACEHOLDER_CARD = [0, 1, 2, 3, 4, 5, 6, 7, 8];
	return (
		<UFOSegment name="confluence-template-skeleton-card-grid">
			<ul css={gridContainerStyles} data-testid="skeleton-template-recommendation-card-grid">
				{NUMBER_OF_PLACEHOLDER_CARD.map((cardNumber, index) => (
					<li
						key={cardNumber}
						css={[gridItemStyles]}
						data-testid={`placeholder-template-card-grid-item-${index}`}
					>
						<SkeletonTemplateCard
							index={index}
							background={TEMPLATE_CARD_BACKGROUNDS[index % TEMPLATE_CARD_BACKGROUNDS.length]}
						/>
					</li>
				))}
			</ul>
		</UFOSegment>
	);
};
